import Command from "@ckeditor/ckeditor5-core/src/command";
import { COMMAND_NAME } from "../constant";

export default class EditCommand extends Command {
  constructor(editor) {
    super(editor);
  }

  refresh() {
    const element = this.editor.model.document.selection.getSelectedElement();
    this.isEnabled = !!element && element.is("element", COMMAND_NAME);
  }

  execute() {
    const model = this.editor.model;
    const viewElement = model.document.selection.getSelectedElement();
    const attributes = viewElement.getAttributes();
    console.log(11111111111);
  }
}